import { mapState, mapMutations } from 'vuex'
import moment from 'moment'
import numeral from 'numeral'
import api from '../service/services.js'
import { ifError } from 'assert'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'

export default {
  data() {
    return {
      search: '',
      date_type: 'date',
      show_type: 0,
      date_time: moment(new Date()).format('YYYY-MM-DD'),
      data_bill: [],
      error_massage: '',
      active: 1,
      totalPages: 0,
      item_perpage: 30,
      limit: 0,
      start: 0,
      loaddata: 0,
      paginateData: [],
      folder: [],
      screenHeight: window.innerHeight - 220,
      isLoading: false,
      data_modal: {},
      date_Expired: moment(new Date()).format('YYYY-MM-DD'),
    }
  },
  components: {
    Loading,
  },
  computed: {
    ...mapState(['user', 'url']),
    ...mapMutations(['checkLogin', 'newDayAdd']),
  },
  methods: {
    fm_number(int) {
      return numeral(int).format('0,0')
    },
    setDate(text) {
      this.date_type = text
      if (this.date_type === 'date') {
        this.date_time = moment(new Date(this.date_time)).format('YYYY-MM-DD')
      } else {
        this.date_time = moment(new Date(this.date_time)).format('YYYY-MM')
      }
      this.getList(this.active)
    },
    setTypeShow(index) {
      this.show_type = index
      this.getList(this.active)
    },
    getList(active) {
      this.start = (active - 1) * this.item_perpage
      this.limit = (active - 1) * this.item_perpage + this.item_perpage
      var obj = {
        search: this.search,
        date: this.date_time,
        active: active,
        start: this.start,
        limit: this.limit,
      }
      // alert(JSON.stringify(obj))
      this.loaddata = 0
      this.data_bill = []
      api.AXbilllist(
        this.url,
        obj,
        (result) => {
          if (result.status === 1) {
            this.data_bill = result.data.bills
            this.totalPages = Math.ceil(
              result.data.count_page / this.item_perpage,
            )
            if (active < 1) {
              this.active = 1
            } else {
              this.active = active
            }
            this.setPage()
          } else {
            this.error_massage = JSON.stringify(ifError)
          }
          this.loaddata = 1
        },
        (error) => {
          alert(JSON.stringify(error))
          this.error_massage = JSON.stringify(error)
          this.loaddata = 1
        },
      )
    },
    setPage() {
      var paginate = []

      for (var i = 0; i < this.totalPages; i++) {
        if (this.active === i + 1) {
          paginate.push({
            active: true,
            text: i + 1,
            number: i + 1,
          })
        } else {
          paginate.push({
            active: false,
            text: i + 1,
            number: i + 1,
          })
        }
      }

      this.paginateData = paginate
    },
    detail(key) {
      if (key) {
        this.$router.push({
          name: 'BillDetail',
          params: {
            key: key,
          },
        })
      } else {
        swal('Error!', 'No Data in Bill!!', 'error')
      }
    },
    addMail(key) {
      if (key) {
        const routeData = this.$router.resolve({
          name: 'Addmail',
          params: {
            key: key,
          },
        })
        window.open(routeData.href, '_blank')
      } else {
        swal('Error!', 'No Data in Bill!!', 'error')
      }
    },
    date_format(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    month_format(date) {
      return moment(date).format('MM/YYYY')
    },
    deleteBill(id) {
      this.deleteBillAll([id])
    },
    deleteBillAll(obj) {
      this.isLoading = true
      var data = []
      obj.forEach((val) => {
        data.push({
          bill_id: val,
        })
      })
      var object = {
        bills: data,
      }
      swal({
        title: 'Alert ?',
        text:
          'Bill deletion It may take a long time. Do you want to delete the billing entry?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          api.AXdeletebill(
            this.url,
            object,
            (result) => {
              swal({
                type: 'success',
                title: 'Deleting',
                text: 'Delete Bills successful!!',
              })
              this.isLoading = false
              this.getList(this.active)
              this.folder = []
            },
            (error) => {
              swal({
                type: 'error',
                title: 'Deleting Error',
                text: JSON.stringify(error),
              })
              this.folder = []
              this.getList(this.active)
              this.isLoading = false
            },
          )
        } else {
          this.isLoading = false
        }
      })
    },
    editexpired(obj) {
      this.data_modal = obj
      this.date_Expired = moment(obj.expired_date).format('YYYY-MM-DD')
      $('#editexpired').modal('show')
    },
    updatebill() {
      var obj = {
        token: this.user.token,
        bill_id: this.data_modal.bill_id,
        bill_date: this.date_Expired,
      }
      api.AXupdateexpired(
        this.url,
        obj,
        (result) => {
          if (result.status === 1) {
            $('#editexpired').modal('hide')
            this.data_modal = {}
            this.getList(1)
            this.date_Expired = moment(new Date()).format('YYYY-MM-DD')
            swal('Good job!', result.data, 'success')
          } else {
            swal('warning !', result.data, 'warning')
            $('#editexpired').modal('hide')
          }
        },
        (error) => {
          $('#editexpired').modal('hide')
          alert(JSON.stringify(error))
        },
      )
    },
  },
  mounted() {
    if (sessionStorage.getItem('users') !== null) {
      try {
        this.checkLogin()
      } catch (e) {
        // location.reload()
      }
      if (this.user.username !== null) {
        this.getList(this.active)
      }
    } else {
      this.$router.push({
        name: 'Login',
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/js/manage_file.js